import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2255de9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "circles-graphic" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"circle large\" data-v-2255de9e></div><div class=\"circle medium\" data-v-2255de9e><div class=\"inner-circle\" data-v-2255de9e></div></div><div class=\"circle small\" data-v-2255de9e><div class=\"inner-circle\" data-v-2255de9e></div></div>", 3)
const _hoisted_5 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}